import { type EventIdentifier, isPwaMode, isWeb, TrackingEventType, useAnalytics } from '@capsicum/common';

export type UseStakeAllFanTokensAnalyticsProps = {
	amount?: number | string;
	eventIdentifier: EventIdentifier;
	networkFee?: null | number;
	partnersAmount?: number | string;
	rewardPoints?: number | string;
	sponsorType?: 'non_sponsored' | 'sponsored';
	status?: 'failed' | 'submitted';
};

export const useStakeAllFanTokensAnalytics = ({
	amount,
	eventIdentifier,
	networkFee,
	partnersAmount,
	rewardPoints,
	sponsorType,
	status
}: UseStakeAllFanTokensAnalyticsProps) => {
	const analytics = useAnalytics();

	const sendStakeAllFanTokensEvent = () => {
		analytics.sendEvent(TrackingEventType.track, `GA::${eventIdentifier}`, {
			extra_parameter: sponsorType,
			feature: 'stake_all',
			ft_amount: amount,
			is_pwa_mode: isWeb() && isPwaMode(),
			partners_amount: partnersAmount,
			reward_points: rewardPoints,
			service_fee: networkFee,
			status: status
		});
	};

	return { sendStakeAllFanTokensEvent };
};
